const isFeatureEnabled = (feature: Feature): boolean => {
    const env = process.env as Record<string, string>;
    if (Object.keys(env).includes(feature.toString())) {
        return JSON.parse(env[feature.toString()]) as boolean;
    }
    return false;
};
enum Feature {
    POLICY_START_DATE_RESOLVER = 'REACT_APP_POLICY_START_DATE_RESOLVER',
    IAM_BE_API = 'REACT_APP_IAM_BE_API',
    DISABLE_CHECKOUT = 'REACT_APP_FEATURE_DISABLE_CHECKOUT',
    HIDE_DUMMY_STEPATHON_POLICY = 'REACT_APP_DUMMY_STEPATHON_FLOW',
    LOCAL_FLAGS = 'REACT_APP_LOCAL_FLAGS',
}

export const isPolicyStartDateResolverEnabled = isFeatureEnabled(Feature.POLICY_START_DATE_RESOLVER);
export const isIamAPIEnabled = isFeatureEnabled(Feature.IAM_BE_API);
export const isDummyStepathonPolicyHidden = isFeatureEnabled(Feature.HIDE_DUMMY_STEPATHON_POLICY);
export const isLocalFlags = isFeatureEnabled(Feature.LOCAL_FLAGS);

export const isCheckoutDisabled = (policyId: string): boolean => {
    const env = process.env as Record<string, string>;
    if (Object.keys(env).includes(Feature.DISABLE_CHECKOUT)) {
        const accountsWithCheckoutDisabled = (JSON.parse(env[Feature.DISABLE_CHECKOUT]) as Array<string>) || [];
        if (accountsWithCheckoutDisabled.includes(policyId)) {
            return true;
        }
    }
    return false;
};
